import PropTypes from 'prop-types';
import { classNames } from '../utils';
import BackButton from 'components/BackButton';
import './NewContainer.scss';

export const NewContainer = ({ header, children, className, isMaxWidthUnset, isBackButton, handleBackButtonClick }) => {
  const containerClasses = classNames({
    'new-uikit-container': true,
    'new-uikit-container-max-width-unset': !!isMaxWidthUnset,
    [className]: true
  });

  return (
    <div className={containerClasses}>
      {isBackButton && (
        <BackButton
          handleBackButton={handleBackButtonClick ? handleBackButtonClick : undefined}
          withoutBottomMargin={true}
        />
      )}
      <div className={'new-container-header'}>
        <p className={'new-container-header-text'}>{header}</p>
      </div>
      {children}
    </div>
  );
};

NewContainer.propTypes = {
  header: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  isMaxWidthUnset: PropTypes.bool,
  isBackButton: PropTypes.bool,
  handleBackButtonClick: PropTypes.func
};
